import React from "react";
import { Box } from "@mui/material";
import OfferedServices from "./OfferedServices";
import BrandsSelection from "./BrandsSelection";
import AdditionalServices from "./AdditionalServices";
import WorkshopInfo from "./WorkshopInfo";
import WorkshopOpenDayAndTime from "./WorkshopOpenDayAndTime";
import ExceptionalClosures from "./ExceptionalClosures";
import QueueDays from "./QueueDays";
import { useWindowSize } from "../../../shared/hooks/useWindowSize";
import WorkshopStatus from "./WorkshopStatus";
import { useSelector } from "react-redux";
import { selectWorkshopDetails } from "../../../app/store/userSlice";
import WorkshopImage from "./WorkshopImage";

const WorkshopSettingsPage = () => {
  const { isMobile } = useWindowSize();
  const workshopDetails = useSelector(selectWorkshopDetails);
  
  const components = [
    <WorkshopImage key="workshop-image" />,
    <QueueDays key="queue-days" />,
    <OfferedServices key="offered-services" />,
    <BrandsSelection key="brands-selection" />,
    <AdditionalServices key="additional-services" />,
    <WorkshopInfo key="workshop-info" />,
    <WorkshopOpenDayAndTime key="workshop-open-day-and-time" />,
    <ExceptionalClosures key="exceptional-closures" />,
  ];

  if(workshopDetails.active) {
    components.push(<WorkshopStatus key="workshop-status" />);
  }else {
    components.unshift(<WorkshopStatus key="workshop-status" />);
  }

  return (
    <Box sx={{ bgcolor: "#f4f5f7", minHeight: "100vh", py: 4 }}>
      <Box sx={{ maxWidth: "100%", mx: "auto", px: !isMobile && 2 }}>
        {components.map((component) => component)}
      </Box>
    </Box>
  );
};

export default WorkshopSettingsPage;
